import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import { useResetFiles } from '../SandboxProvider';
import LineNumbersButton from './LineNumbersButton';
import ResetButton from './ResetButton';
import FormatButton from './ConnectedFormatButton';
import CodeSandboxButton from './CodeSandboxButton';

const ACCENT_COLOR = 'hsl(50deg 100% 50%)';

interface Props {
  title?: string;
}

function Toolbar({ title }: Props) {
  const resetFiles = useResetFiles();

  return (
    <Wrapper>
      <Title>{title || 'Code Playground'} </Title>
      <Actions>
        <ResetButton
          accentColor={ACCENT_COLOR}
          handleReset={resetFiles}
        />
        <LineNumbersButton accentColor={ACCENT_COLOR} />

        <FormatButton accentColor={ACCENT_COLOR} />
        <CodeSandboxButton accentColor={ACCENT_COLOR} />
      </Actions>
    </Wrapper>
  );
}

const Wrapper = styled.header`
  position: relative;
  display: flex;
  justify-content: space-between;
  min-height: 32px;
  line-height: 2rem;
  padding: 0 16px;
  background: var(--color-gray-100);
  border-radius: 5px 5px 0 0;

  @media ${BREAKPOINTS.smAndSmaller} {
    border-radius: 0px;
  }
`;

const Title = styled.p`
  font-size: 0.875rem;
  line-height: inherit;
  font-weight: var(--font-weight-medium);
  color: var(--color-gray-800);
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  /* Optical alignment */
  margin-right: -10px;

  color: var(--color-text);

  @media ${BREAKPOINTS.smAndSmaller} {
    display: none;
  }
`;

export default Toolbar;
